import moment from 'moment';

import formatDatesToLocale from '@common/utils/formatDatesToLocale';

export const cancellationMessageKeys = {
  free: 'cancellationPolicy.free',
  partial: 'cancellationPolicy'
};

export const hoursAfterAcceptanceKeys = {
  afterBookingAccepted:
    'cancellationPolicy.hoursAfterAcceptance.afterBookingAccepted',
  bookNow: 'cancellationPolicy.hoursAfterAcceptance.bookNow',
  title: 'cancellationPolicy.free.title'
};

export const humaniseRefund = ({ refundType, refundValue } = {}) =>
  `${refundValue}${refundType === 'percentage' ? '%' : ''}`;

export const cancellationMessageOptions = (cancellationDeadline = {}) => {
  let hour;
  let date;
  const { deadlineType, deadlineValue } = cancellationDeadline;
  switch (deadlineType) {
    case 'date':
      hour = moment.utc(deadlineValue).format('HH:mm');
      date = moment.utc(deadlineValue).format(formatDatesToLocale());
      break;
    case 'hoursAfterAcceptance':
      hour = deadlineValue;
      date = null;
      break;
    default:
  }

  return {
    refund: humaniseRefund(cancellationDeadline),
    hour,
    date
  };
};

// Formats cancellationPolicies data
export const formatSimpleCancellationDate = date => ({
  hour: moment.utc(date).format('HH:mm'),
  date: moment.utc(date).format(formatDatesToLocale())
});

export const getCurrentCancellationDeadline = deadlines =>
  deadlines &&
  deadlines.find(
    deadline => deadline && deadline.current && deadline.refundValue
  );

export const getCancellationDiscountType = ({ refundType, refundValue } = {}) =>
  refundType === 'percentage' && refundValue === 100 ? 'free' : 'partial';

export default {
  cancellationMessageKeys,
  humaniseRefund,
  cancellationMessageOptions,
  getCurrentCancellationDeadline,
  getCancellationDiscountType,
  formatSimpleCancellationDate
};
